export const zips = {
  'pers-fotos': '/zip/pers-fotos.zip',
  'social-toolkit': '/zip/social-toolkit.zip',
  'thuisgekookt-logos': '/zip/thuisgekookt-logos.zip'
} as const

export const videos = {
  'begin-het-jaar-goed-thuiskok-fatma': '/videos/begin-het-jaar-goed-thuiskok-fatma',
  'begin-het-jaar-goed-thuiskok-kevin': '/videos/begin-het-jaar-goed-thuiskok-kevin',
  'bert-1': '/videos/bert-1',
  'bert-2': '/videos/bert-2',
  'david-en-carla': '/videos/david-en-carla',
  'goede-voornemens': '/videos/goede-voornemens',
  kookmeer: '/videos/kookmeer',
  'minder-zorgen-1': '/videos/minder-zorgen-1',
  'minder-zorgen-2': '/videos/minder-zorgen-2',
  nikki: '/videos/nikki',
  tessa: '/videos/tessa',
  tina: '/videos/tina'
} as const

export const pdfs = {
  doneren: '/pdf/doneren/periodieke-schenking.pdf',
  impactonderzoeken: {
    'impactonderzoek-2025': '/pdf/impactonderzoek/impactonderzoek-2025.pdf'
  },
  infographic: {
    'impactonderzoeken-2023-2024': '/pdf/infographic/impactonderzoeken-2023-2024.pdf',
    'projectplan-2025': '/pdf/infographic/projectplan-2025.pdf',
    'resultaten-2024': '/pdf/infographic/resultaten-2024.pdf'
  },
  kookboek: {
    'de-wereld-op-je-bord': '/pdf/kookboek/de-wereld-op-je-bord.pdf'
  },
  maaltijdzoeker: {
    // Files for mails
    // 'hygiene-regels': '/pdf/maaltijdzoeker/hygiene-regels.pdf',
    // 'tips-eerste-kennismaking': '/pdf/maaltijdzoeker/tips-eerste-kennismaking.pdf',
    // 'tips-match': '/pdf/maaltijdzoeker/tips-match.pdf'
  },
  organisatie: {
    beleidsplan: '/pdf/organisatie/beleidsplan.pdf',
    'jaarverslag-2021': '/pdf/organisatie/jaarverslag-2021.pdf',
    'jaarverslag-2022': '/pdf/organisatie/jaarverslag-2022.pdf',
    'jaarverslag-2023': '/pdf/organisatie/jaarverslag-2023.pdf',
    'jaarverslag-2024': '/pdf/organisatie/jaarverslag-2024.pdf',
    'jaarverslag-2025': '/pdf/organisatie/jaarverslag-2025.pdf',
    'reglement-raad-van-toezicht': '/pdf/organisatie/reglement-raad-van-toezicht.pdf',
    statuten: '/pdf/organisatie/statuten.pdf'
  },
  thuiskok: {
    'hygiene-regels': '/pdf/thuiskok/hygiene-regels.pdf',
    'sociale-omgangsregels': '/pdf/thuiskok/sociale-omgangsregels.pdf'
    // Files for mails
    // 'tips-eerste-kennismaking': '/pdf/thuiskok/tips-eerste-kennismaking.pdf',
    // 'tips-match': '/pdf/thuiskok/tips-match.pdf'
  },
  // Files for mails
  // 'checklist-eerste-kennismaking-maaltijdzoeker':
  //   '/pdf/checklist-eerste-kennismaking-maaltijdzoeker.pdf',
  // 'checklist-eerste-kennismaking-thuiskok':
  //   '/pdf/checklist-eerste-kennismaking-thuiskok.pdf',
  'digitale-flyer': '/pdf/digitale-flyer.pdf',
  integriteitsbeleid: '/pdf/integriteitsbeleid.pdf',
  vrijwilligersbeleid: '/pdf/vrijwilligersbeleid.pdf'
  // 'kookmeer-kookboek': '/pdf/kookmeer-kookboek.pdf',
  // 'tips-match-aanvrager': '/pdf/tips-match-aanvrager.pdf',
  // 'tips-match-thuiskok': '/pdf/tips-match-thuiskok.pdf'
} as const
